import { Injectable } from '@angular/core';
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../environments/environment";
import { GenericHttpService } from "../../../services/generic-http.service";
import { Observable } from "rxjs";
import { GenericUtils } from './../../../utilities/generic-utils';
import * as moment from "moment";

@Injectable({
  providedIn: 'root'
})
export class DataService {
  apiUrl = environment.gateWayHost;
  editItem: any;
  config: any;
  intervel: any;
  weekcount = 0
  getTimeType = {

    'hour': function (time) {
      return `${moment(time).format('HH:mm')} hours`;
    },
    'day': function (time) {
      return moment(time).format('DD-MMM');
    },
    'week': function (time) {
      //return moment(time).format('dddd');
      return `${++this.weekcount} week`;
    }.bind(this),
    'month': function (time) {
      return moment(time).format('MMM');
    }
  };
  constructor(public generic: GenericHttpService, private genericUtils: GenericUtils) { }

  getData(url, config, params): Observable<any> {
    this.intervel = params['interval_type'];
    url.includes('json') ? this.apiUrl = environment.baseUrl : this.apiUrl = environment.gateWayHost;
    this.intervel = params['interval_type'] || '';
    const option = {
      method: "GET",
      url: `${this.apiUrl}${url}`,
      query: params
    };
    this.config = config;
    const functionToExecute = this[this.config['functionToCall']].bind(this);
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(functionToExecute)
    );
  }

  processOverview(data: any) {
    if (!Object.keys(data.data).length) return null;
    const total = [],
      //dispatched = [],
      cancelled = [],
      delivered = [],
      returned = [],
      labels = [];

    Object.keys(data.data).forEach(ele => {
      labels.push(this.getTimeType[this.intervel](ele));
      total.push((+data.data[ele].total || 0) - (+data.data[ele].cancelled || 0));
      //dispatched.push(data.data[ele].in_transit || 0);
      cancelled.push(data.data[ele].cancelled || 0);
      delivered.push(data.data[ele].delivered || 0);
      returned.push(data.data[ele].Returned || 0);
    });
    this.weekcount = 0;
    return { labels, values: [total, cancelled, delivered, returned] };
  };

  processFillRateTrend(data: any) {
    if (!Object.keys(data.data).length) return null;
    let percentage_total = 0;
    const labels = [], fillRate = [];
    Object.keys(data.data).forEach(ele => {
      labels.push(this.getTimeType.day(ele));
      const percentage = ((+data.data[ele].processed_qty || 0) / (+data.data[ele].ordered_qty || 0)) * 100 || 0;
      fillRate.push(+percentage.toFixed(2));
      percentage_total += percentage;
    });

    if (!percentage_total) return null;
    return { labels, values: [fillRate] };
  }

  processInboundDispatchedTrend(data: any) {
    if (!Object.keys(data.data).length) return null;
    const labels = [], inbound_qty = [], outbound_qty = [];
    let total_inbound = 0, total_outbound = 0;

    Object.keys(data.data).forEach(ele => {
      labels.push(this.getTimeType[this.intervel](ele));
      inbound_qty.push(+data.data[ele].inbound_qty || 0);
      total_inbound += (+data.data[ele].inbound_qty);
      total_outbound += (+data.data[ele].outbound_qty);
      outbound_qty.push(+data.data[ele].outbound_qty || 0);
    });
    if (!total_inbound && !total_outbound) return null;
    this.weekcount = 0;
    return { labels, values: [inbound_qty, outbound_qty] };
  }
  processTrendAtGlance(data: any) {
    if (!Object.keys(data.data).length) return null;
    const
      orderedQty = [],
      inboundQty = [],
      inTransit = [],
      labels = [];
    let total = 0;

    Object.keys(data.data).forEach(ele => {
      labels.push(this.getTimeType[this.intervel](ele));
      orderedQty.push(+data.data[ele].order_created_qty || 0);
      inboundQty.push(+data.data[ele].inbound_qty || 0);
      inTransit.push(+data.data[ele].order_shipped_qty || 0);
      total += ((+data.data[ele].order_shipped_qty) + (+data.data[ele].inbound_qty) + (+data.data[ele].order_created_qty));
    });
    this.weekcount = 0;
    if (!total) return null;
    return { labels, values: [orderedQty, inboundQty, inTransit] };
  };

  processTransportationSLA(data: any) {

    if (!data.data && !data.data.length && !Object.keys(data.data[0])) return null;

    const originaldata = data.data[0][Object.keys(data.data[0])[0]];

    if (originaldata && originaldata.length) {

      const slaQty = [], deliveredqQty = [], labels = [];
      let total = 0;

      originaldata.forEach(ele => {
        if (ele.deliver_by && ele.deliver_by !== 'Total') {
          labels.push(this.getTimeType[this.intervel](ele.deliver_by));
          slaQty.push(+(ele.sla).toFixed(2) || 0);
          deliveredqQty.push(+ele.dlv_qty_in_tat || 0);
          total += ((+ele.dlv_qty_in_tat) + (+ele.sla));
        }
      });
      this.weekcount = 0;
      if (!total) return null;
      return { labels, values: [slaQty, deliveredqQty] };
    } else {
      return null;
    }
  }

  processFirstAttempt(data: any) {
    if (!data.data && !data.data.length && !Object.keys(data.data[0])) return null;

    const originaldata = data.data[0][Object.keys(data.data[0])[0]];
    if (originaldata && originaldata.length) {

      const firtsAttemptQty = [], labels = [];
      let total = 0;

      originaldata.forEach(ele => {
        if (ele.deliver_by && ele.deliver_by !== 'Total') {
          labels.push(this.getTimeType[this.intervel](ele.deliver_by));
          firtsAttemptQty.push(+ele.first_attempt_sla.toFixed(2) || 0);
          total += (+ele.first_attempt_sla.toFixed(2));
        }
      });
      this.weekcount = 0;
      if (!total) return null;
      return { labels, values: [firtsAttemptQty] };
    } else {
      return null;
    }
  }

  processReturnedQty(data: any) {

    if (!data.data && !data.data.length && !Object.keys(data.data[0])) return null;

    const originaldata = data.data[0][Object.keys(data.data[0])[0]];
    if (originaldata && originaldata.length) {

      const returnedQty = [], labels = [];
      let total = 0;

      originaldata.forEach(ele => {
        if (ele.deliver_by && ele.deliver_by !== 'Total') {
          labels.push(this.getTimeType[this.intervel](ele.deliver_by));
          returnedQty.push(+ele.returned_qty || 0);
          total += (+ele.returned_qty);
        }
      });
      this.weekcount = 0;
      if (!total) return null;
      return { labels, values: [returnedQty] };
    } else {
      return null;
    }
  }

  createChart(chartData, options) {
    const chart = this.genericUtils.deepCopyFunction(options[0]);
    chart.xAxis[0].categories = chartData.labels;
    for (let index = 0; index < chartData.values.length; index++) {
      chart.series[index].data = chartData.values[index];
    }
    return chart;
  }

}
